import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationDesigner } from "./shared/data.service";
import { UserService } from "../../../shared";
import { wsClickOnceDeployInfo } from "./shared/wsClickOnceDeployInfo";

@Component({
	selector: "app-multi-station-design",
	templateUrl: "./multi-station-design.component.html",
	styleUrls: ["./multi-station-design.component.css"],
})
export class MultiStationDesignComponent implements OnInit {
	constructor(private dataService: DataService_MultiStationDesigner, private userService: UserService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;

	//	Printers List
	public lstClickOnceDeploy: wsClickOnceDeployInfo[] = [];

	public CAASSVisitorIDDeployUrl: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.isBusy = true;
		this.dataService.ClickOnceDeployURLSelect().subscribe((data) => this.ClickOnceDeployURLSelect_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ClickOnceDeployURLSelect_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ClickOnceDeployURLSelect_Complete(data: any) {
		this.lstClickOnceDeploy = data;

		if (this.lstClickOnceDeploy.length == 1) {
			this.CAASSVisitorIDDeployUrl = this.lstClickOnceDeploy[0].CAASS10VisitorIDDeploy;
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCAASSVisitorIDDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onCAASSVisitorIDDeploy() {
		window.open(this.CAASSVisitorIDDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
